import Vue from 'vue';
import VueRouter from 'vue-router';
import Index from '../pages/index.vue';
import login from '../pages/login.vue';

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Index,
    meta: {
      title: ''
    }
  },
  {
    path: '/login',
    component: login,
    name: 'login',
    meta: {
      title: '登录'
    }
  },

  /*********周边服务**********/
  {
    path: '/servicesManager',
    component: () => import('../pages/router.vue'),
    name: 'servicesManager',
    meta: {
      title: '周边服务',
      keepAlive: true
    },
    children: [
      {
        path: '/servicesManager/:pageType?/search',
        component: () => import('../pages/servicesManager/search/index.vue'),
        name: 'servicesManager.search',
        meta: {
          title: '服务申请',
          keepAlive: true
        }
      },
      {
        component: () => import('../pages/router.vue'),
        path: '/servicesManagerOrder',
        name: 'servicesManagerOrder',
        meta: {
          title: '服务订单',
          keepAlive: true
        },
        children: [
          {
            path: '/servicesManager/order',
            name: 'servicesManager.order',
            component: () => import('../pages/servicesManager/order/index.vue'),
            meta: {
              keepAlive: true
            }
          },
          {
            path: '/servicesManager/order/editForm',
            name: 'servicesManager.order.editForm',
            component: () => import('../pages/servicesManager/order/editForm.vue'),
            meta: {
              title: '',
              parentUrl: '/servicesManager/order',
              keepAlive: true
            }
          }
        ]
      }
    ]
  },
  /*********组织机构**********/
  {
    path: '/orgManage',
    component: () => import('../pages/router.vue'),
    redirect: '/orgManage/index',
    name: 'orgManage',
    meta: {
      title: '组织管理',
      keepAlive: true
    },
    children: [
      {
        path: '/orgManage/index',
        name: 'orgManage.index',
        component: () => import('../pages/orgManage/orgManage/merchantManage.vue'),
        meta: {
          // IFA管理
          title: '',
          // keepAlive: true
        }
      },
      {
        path: '/orgManage/productCommission',
        component: () => import('../pages/orgManage/orgManage/productCommission.vue'),
        name: 'productCommission',
        meta: {
          title: '详情',
          keepAlive: true,
          parentUrl: '/orgManage/index'
        }
      },
      {
        path: '/orgManage/active',
        name: 'orgManage.active',
        component: () => import('../pages/orgManage/activeManage/index.vue'),
        meta: {
          title: 'active状态管理',
          // keepAlive: true
        }
      },
      {
        path: '/orgManage/ifaCommissionFile/index',
        name: 'orgManage.ifaCommissionFile',
        component: () => import('../pages/orgManage/ifaCommissionFile/index.vue'),
        meta: {
          title: 'IFA佣金政策文件',
          keepAlive: true
        }
      }
    ]
  },
  // 账号管理
  {
    path: '/accountManager/account',
    meta: {
      title: '系统账号管理'
    },
    component: () => import('../pages/accountManager/account/index.vue')
  },
  /*********积分查询**********/
  {
    path: '/settlementManage',
    meta: {
      title: '积分查询'
    },
    component: () => import('../pages/router'),
    children: [
      {
        path: '/settlementManage/bill',
        meta: {
          title: '账单确认'
        },
        component: () => import('../pages/settlementManage/bill/index.vue')
      }
    ]
  },
  {
    path: '/basicLaw/index',
    redirect: '/basicLaw/index',
    meta: {
      title: 'IFA结算'
    },
    component: () => import('../pages/router'),
    children: [
      {
        path: '/settlementManage/index',
        component: () => import('../pages/settlementManage/index.vue'),
        meta: {
          title: '佣金项结算',
          keepAlive: true
        }
      },
      {
        path: '/basicLaw/index',
        component: () => import('../pages/basicLaw/index.vue'),
        meta: {
          title: '结算报表',
          keepAlive: true
        }
      },
      {
        path: '/basicLaw/add',
        component: () => import('../pages/basicLaw/add/index.vue'),
        meta: {
          title: '新增结算报表',
          keepAlive: true
        }
      },
      {
        path: '/basicLaw/edit',
        component: () => import('../pages/basicLaw/add/index.vue'),
        meta: {
          title: '编辑结算报表',
          keepAlive: true
        }
      },
      {
        path: '/basicLaw/settlementDetail',
        component: () => import('../pages/basicLaw/add/settlementDetail.vue'),
        meta: {
          title: '代理人佣金详情'
        }
      },
      {
        path: '/basicLaw/checkAccounts',
        component: () => import('../pages/basicLaw/checkAccounts/index.vue'),
        meta: {
          title: '对账与打款',
          keepAlive: true
        }
      },
      {
        path: '/basicLaw/checkAccounts/settlementDetail',
        component: () => import('../pages/basicLaw/checkAccounts/settlementDetail.vue'),
        meta: {
          title: '详情',
          keepAlive: true
        }
      }
    ]
  },
  {
    path: '/companyManage/index',
    redirect: '/companyManage/index',
    meta: {
      title: '保司管理'
    },
    component: () => import('../pages/router'),
    children: [
      {
        path: '/companyManage/index',
        component: () => import('../pages/companyManage/index.vue'),
        meta: {
          title: '',
          keepAlive: true
        }
      },
      {
        path: '/companyManage/detail',
        component: () => import('../pages/companyManage/detail.vue'),
        meta: {
          title: '详情',
          parentUrl: '/companyManage/index',
          keepAlive: true
        }
      }
    ]
  },
  /*********产品管理**********/
  {
    path: '/operate/productManage/product',
    redirect: '/operate/productManage/index',
    meta: {
      title: '产品管理'
    },
    component: () => import('../pages/operate/productManage/product/index'),
    children: [
      {
        path: '/operate/productManage/index',
        component: () => import('../pages/operate/productManage/product/product.vue'),
        name: 'productManage',
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/operate/productManage/product/details/productCommission',
        name: 'productCommission',
        component: () => import('../pages/operate/productManage/product/details/productCommissionNew.vue'),
        meta: {
          title: '积分详情',
          parentUrl: '/operate/productManage/index',
          keepAlive: true
        }
      },
      {
        path: '/operate/productManage/product/details/productCommissionIFA',
        name: 'productCommissionIFA',
        component: () => import('../pages/operate/productManage/product/details/productCommissionNew.vue'),
        meta: {
          title: '佣金详情',
          parentUrl: '/operate/productManage/index',
          keepAlive: true
        }
      },
      {
        path: '/operate/productManage/product/details/productDeatail',
        name: 'product.productDeatail',
        component: () => import('../pages/operate/productManage/product/details/productDeatail.vue'),
        meta: {
          title: '产品详情',
          parentUrl: '/operate/productManage/index',
          keepAlive: true
        }
      }
    ]
  },
  /*********预约签单管理**********/
  {
    path: '/operate/appointment',
    component: () => import('../pages/router'),
    meta: {
      title: '预约签单管理'
    },
    children: [
      {
        path: '/operate/appointmentManager/index',
        component: () => import('../pages/operate/appointmentManager/index.vue'),
        meta: {
          title: '',
          keepAlive: true
        }
      },
      {
        path: '/operate/appointmentManager/detail',
        component: () => import('../pages/operate/appointmentManager/detail.vue'),
        meta: {
          keepAlive: true,
          parentUrl: '/operate/appointmentManager/index',
          title: '预约详情'
        }
      }
    ]
  },

  /*********续费管理**********/
  {
    path: '/operate/renewalManage',
    component: () => import('../pages/router'),
    meta: {
      title: '续费管理'
    },
    children: [
      {
        path: '/operate/renewalManage/index',
        component: () => import('../pages/operate/renewalManage/index.vue'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/operate/renewalManage/renewalDetail',
        component: () => import('../pages/operate/renewalManage/renewalDetail/renewalDetail.vue'),
        meta: {
          keepAlive: true,
          parentUrl: '/operate/renewalManage/index',
          title: '续费详情'
        }
      }
    ]
  },

  /*********保单管理**********/
  {
    path: '/operate/orderManage',
    redirect: '/operate/orderManage/order',
    meta: {
      title: '保单管理'
    },
    component: () => import('../pages/router'),
    children: [
      {
        path: '/operate/orderManage/insuredOrder',
        name: 'insureOrder',
        component: () => import('../pages/operate/orderManage/insuredOrder/order.vue'),
        meta: {
          title: '',
          keepAlive: true
        }
      },
      {
        path: '/operate/orderManage/insuredOrder/policyDetail',
        name: 'insureOrder',
        component: () => import('../pages/operate/orderManage/insuredOrder/policyDetail/policyDetail.vue'),
        meta: {
          title: '',
          parentUrl: '/operate/orderManage/insuredOrder',
          keepAlive: true
        }
      }
    ]
  },

  /*********活动中心**********/
  {
    path: '/operate/activityCenter',
    redirect: '/operate/activityCenter/list',
    name: 'activityCenter',
    component: () => import('../pages/router'),
    meta: {
      title: '活动中心'
    },
    children: [
      {
        path: '/operate/activityCenter/list',
        component: () => import('../pages/operate/activityCenter/list.vue'),
        name: 'activityManagerList',
        meta: {
          parentUrl: '/operate/activityCenter',
          keepAlive: true
        }
      },
      {
        path: '/operate/activityCenter/detail',
        component: () => import('../pages/operate/activityCenter/detail.vue'),
        name: 'activityManagerDetail',
        meta: {
          parentUrl: '/operate/activityCenter',
          title: '活动详情',
          keepAlive: true,
          formMode: 'detail'
        }
      }
    ]
  },

  /*********资料库**********/
  {
    path: '/operate/fileDownload',
    redirect: '/operate/fileDownload/productPoster',
    meta: {
      title: '资料库'
    },
    component: () => import('../pages/router'),
    children: [
      {
        path: '/operate/fileDownload/signManage',
        redirect: '/operate/fileDownload/signManage',
        component: () => import('../pages/router'),
        meta: {
          title: '签单事项'
        },
        children: [
          {
            path: '/operate/fileDownload/signManage',
            component: () => import('../pages/operate/fileDownload/signManage.vue'),
            meta: {
              title: '',
              keepAlive: true
            }
          },
          {
            path: '/operate/fileDownload/signManage/detail',
            component: () => import('../pages/operate/fileDownload/detail.vue'),
            meta: {
              title: '详情',
              parentUrl: '/operate/fileDownload/signManage'
            }
          }
        ]
      },
      {
        path: '/operate/fileDownload/offsetManage',
        component: () => import('../pages/operate/fileDownload/offsetManage'),
        meta: {
          title: '最新优惠'
        }
      },
      {
        path: '/operate/fileDownload/marketingMaterials',
        component: () => import('../pages/operate/fileDownload/marketingMaterials.vue'),
        meta: {
          title: '营销资料'
        }
      },
      {
        path: '/operate/fileDownload/hotNews',
        component: () => import('../pages/operate/fileDownload/hotNews.vue'),
        meta: {
          title: '热点资讯'
        }
      },
      {
        path: '/operate/fileDownload/productInformation',
        component: () => import('../pages/operate/fileDownload/productInformation'),
        meta: {
          title: '产品资料'
        }
      },
      {
        path: '/operate/fileDownload/other',
        component: () => import('../pages/operate/fileDownload/other.vue'),
        meta: {
          title: '其他资料',
          keepAlive: true
        }
      },
      {
        path: '/operate/fileDownload/productEvaluation',
        redirect: '/operate/fileDownload/productEvaluation',
        component: () => import('../pages/router'),
        meta: {
          title: '产品测评'
        },
        children: [
          {
            path: '/operate/fileDownload/productEvaluation',
            component: () => import('../pages/operate/fileDownload/productEvaluation.vue'),
            meta: {
              title: '',
              keepAlive: true
            }
          },
          {
            path: '/operate/fileDownload/signManage/detail',
            component: () => import('../pages/operate/fileDownload/detail.vue'),
            meta: {
              title: '详情',
              parentUrl: '/operate/fileDownload/signManage'
            }
          }
        ]
      },
      {
        path: '/operate/fileDownload/reservation',
        component: () => import('../pages/operate/fileDownload/reservation'),
        meta: {
          title: '预约模版',
          keepAlive: true
        }
      },
      {
        path: '/operate/fileDownload/payGuide',
        component: () => import('../pages/operate/fileDownload/payGuide'),
        meta: {
          title: '缴费指引'
        }
      },
      {
        path: '/operate/dataManage',
        component: () => import('../pages/operate/dataManage'),
        meta: {
          title: '资料管理'
        }
      }
    ]
  },
  // 台账管理
  {
    path: '/operate/ledgerManage',
    redirect: '/operate/ledgerManage/confirmPoints',
    name: 'ledgerManage',
    meta: {
      title: '介绍费账单'
    },
    component: () => import('../pages/router'),
    children: [
      {
        path: '/operate/ledgerManage/confirmPoints',
        name: 'ledgerManage_confirmPoints',
        meta: {
          parentUrl: '/operate/ledgerManage',
          keepAlive: true
        },
        component: () => import('../pages/operate/ledgerManage/confirmPoints/confirmPoints.vue')
      },
      {
        path: '/operate/ledgerManage/confirmPoints/detail',
        name: 'ledgerManage_confirmPoints_detail',
        meta: {
          parentUrl: '/operate/ledgerManage/confirmPoints',
          title: '明细',
          keepAlive: true
        },
        component: () => import('../pages/operate/ledgerManage/confirmPoints/detail.vue')
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

let modalHistoryList = [];
router.afterEach((to, from) => {
  const list = [];
  modalHistoryList.forEach((item, i) => {
    if (to.fullPath == item.url) {
      item.vueObj.visible = true;
    } else {
      list.push(item);
    }
  });
  modalHistoryList = list;
});

router.beforeEach((to, from, next) => {
  // 隐藏所有弹窗
  document.querySelectorAll('.ivu-modal-wrap').forEach(item => {
    saveModalHistory(from, item.parentNode.__vue__);
    item.parentNode.__vue__ && item.parentNode.__vue__.close && item.parentNode.__vue__.close();
  });
  // 抽屉
  document.querySelectorAll('.ivu-drawer-wrap').forEach(item => {
    saveModalHistory(from, item.parentNode.__vue__);
    item.parentNode.__vue__ && item.parentNode.__vue__.close && item.parentNode.__vue__.close();
  });
  // sessionStorage.removeItem('componentList')
  // window.vm = ''
  let hasLogin = localStorage.getItem('hasLogin');
  if (to.name === 'login') {
    if (hasLogin) {
      next('/');
    } else {
      next();
    }
  } else {
    if (!hasLogin) {
      top.location.replace('/login');
    } else {
      const url = to.path;
      if (url && url != '/' && url != '/home' && url != '/empty') {
        const arr = [];
        to.matched.forEach(item => {
          if (item.meta.title && item.meta.title != '首页') {
            arr.push({
              name: item.meta.title,
              path: item.path,
              noclick: item.path ? false : true
            });
          }
        });
        window.parent.postMessage(
          {
            updateNav: url,
            appMessage: true,
            nav: arr,
            parentUrl: to.meta.parentUrl ? to.meta.parentUrl : undefined
          },
          '*'
        );
        // tag消息
        const matched = to.matched.filter(item => {
          return !!item.meta.title;
        });
        window.parent.postMessage(
          {
            webChange: {
              path: to.path,
              fullPath: to.fullPath,
              title: matched.length ? matched[matched.length - 1].meta.title : '',
              parentUrl: to.meta.parentUrl ? to.meta.parentUrl : undefined
            },
            appMessage: true
          },
          '*'
        );
      }
      next();
    }
  }
});
// 处理发版导致的缓存报错
router.onError(error => {
  // const isError = error.message.includes("Cannot read properties")||error.message.includes("Loading chunk")
  const isError = error.message;
  const targetPath = router.history.pending.fullPath;
  console.log('router.onError', targetPath, error);
  if (isError) {
    let url = targetPath;
    if (url.includes('?')) {
      url += '&t=' + Date.now();
    } else {
      url += '?t=' + Date.now();
    }
    window.setTimeout(() => {
      location.replace(url);
    }, 5000);
  }
});
function saveModalHistory(from, vueObj) {
  if (!vueObj) {
    return;
  }
  if (vueObj.visible) {
    if (vueObj.$parent.visible) {
      modalHistoryList.push({
        url: from.fullPath,
        vueObj: vueObj.$parent
      });
    } else {
      modalHistoryList.push({
        url: from.fullPath,
        vueObj: vueObj
      });
    }
  }
}
export default router;
